import { State } from '@/store/store'
import { ICaregiver } from '../caregiver/states'
import { IJob } from '../job/states'
import { IPatient } from '../patient/states'
import { IUser, IUserList } from '../user/states'

export class ScheduleState {
  public list: ScheduleList
  public byId: ISchedule
  public update: object
  public listUser: ScheduleUserList
  public listByUser: ScheduleUserList[]
  public listByJob: ScheduleUserList
  public listHoliday: HodidayList
  public stopJob: object
  public logJobList: ITimeline & IJob
  public logPatientList: ITimeline & IPatient

  constructor() {
    this.list = {
      column: [],
      itemCount: 0,
      page: 1,
      pageCount: 1,
      result: [],
      defaultFilter: {},
    }
    this.byId = {
      _id: '',
      userId: '',
      centerId: '',
      jobId: '',
      startDate: '',
      endDate: '',
      startTime: '',
      endTime: '',
      priceDetail: '',
      totalPrice: 0,
      logs: [],
    }
    this.listUser = {
      result: [],
    }
    this.listByUser = []
    this.listByJob = {
      result: [],
    }
    this.listHoliday = {
      data: [
        {
          _id: '',
          date: '',
          name: 'วันขึ้นปีใหม่',
        },
      ],
      itemCount: 0,
    }
    this.stopJob = {}
    this.logJobList = null
    this.logPatientList = null
  }
}

export interface ScheduleList {
  column: Array<{
    text: string
    value: string
    type?: string
    options?: {
      orderable?: boolean
      lengthLimit?: number
      filter?: boolean
      operation: string[],
    },
  }>
  defaultFilter: object
  itemCount: number
  page: number
  pageCount: number
  result: ISchedule[]
}

export interface ISchedule {
    _id: string,
    userId: string,
    jobId?: string,
    centerId: string,
    startDate: string,
    endDate: string,
    startTime: string,
    endTime: string,
    priceDetail: any,
    totalPrice: number,
    logs: ILog[],
    status?: string,
    userName?: string,
}

export interface ScheduleUserList {
  result: IUser[]
}

export interface HodidayList {
  itemCount: number,
  data: Array<{
    _id: string,
    date: string,
    name: string,
  }>
}

export interface IHodiday {
  _id: string,
  date: string,
  name: string,
}

export interface ITimeline {
  careGivers: {
    [key: string]: ICaregiver,
  },
  schedules: ISchedule[],
  patient?: IPatient
  jobs?: {
    [key: string]: IJob,
  }
}

export interface IScheduleLog {
  date: string,
  startTime: string,
  endTime: string,
  logs: ILog[],
  centerId: string,
  createdAt: number,
  jobId: string,
  priceDetail: object[]
  status: string,
  totalPrice: number,
  updatedAt: number,
  userId: string,
  users: Array<{
    createdAt: number,
    updatedAt: number,
    userId: string,
  }>,
  _id: string,
}

export interface ILog {
  image: string,
  text: string,
  createdAt: number,
}

export default ScheduleState
